module.exports = __webpack_public_path__ + "img/inrpac.9da40dc5.jpg";